import { EmergencyContact, Insurance, InsuranceArchiveReason, InsuranceDetails, State, UserProfile } from '@uplift/api';
import { AddressType, UserContact } from '@uplift/types';

export type AddressTypeWithStateProfileType = {
  stateProfile?: State;
} & AddressType;

export type ProfileDataType = {
  profileId: string;
  preferredName: string;
  dob: string;
  sex: UserProfile['sex'];
  pronouns: UserProfile['pronouns'];
  emergencyContact: EmergencyContact;
  mobileContact: Pick<UserContact, 'value' | 'id' | 'name' | 'type'> | null;
  homeContact: Pick<UserContact, 'value' | 'id' | 'name' | 'type'> | null;
} & AddressTypeWithStateProfileType;

export type InsuranceDataType = {
  id: string;
  companyName: string;
  planId: string;
  isPrimary: boolean;
  companyId: string;
  subscriberId: string;
  groupNumber: string;
  insuranceCardFront: string;
  insuranceCardBack: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  createdAt: string;
  createdBy?: string;
  createdByFullName?: string;
  archivedByFullName?: string;
  archivedAt?: string;
  archivedBy?: string;
  archiveReason?: InsuranceArchiveReason;
  isNonPartnerInsurance?: boolean;
} & AddressTypeWithStateProfileType & Pick<Insurance, 'isMedicaid' | 'isSecondaryInsurance'> & Partial<Omit<InsuranceDetails, 'insuranceId'>>;

export type MatchingProvidersInsurancesDataType = {
  providerId: string;
  providerName: string;
  insurances: {
    id: string;
  }[];
};

export type InsuranceCompanyType = {
  name: string;
  id: string;
  metaGrouping: string;
};

export const enum InsuranceSection {
  primaryInsurance = 'primaryInsurance',
  secondaryInsurance = 'secondaryInsurance',
}

export type InsuranceSettingsType = {
  userId: string;
};

export const enum AddInsuranceSection {
  addPrimaryInsurance = 'addPrimaryInsurance',
  addSecondaryInsurance = 'addSecondaryInsurance',
  replacePrimaryInsurance = 'replacePrimaryInsurance'
}

export const enum AddInsuranceView {
  details = 'details',
  detailsIsPrimaryInsurance = 'detailsIsPrimaryInsurance',
  card = 'card',
  primarySubscriber = 'primarySubscriber'
}
